var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',{ref:"numeric",attrs:{"placeholder":_vm.placeholder,"state":_vm.state,"type":"tel","lazy-formatter":""},on:{"blur":_vm.onBlurHandler,"change":_vm.onInputHandler,"focus":_vm.onFocusHandler},model:{value:(_vm.amount),callback:function ($$v) {_vm.amount=$$v},expression:"amount"}})
}
var staticRenderFns = []

export { render, staticRenderFns }